import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getReviewToken = createServerFn()
  .validator((data) => data)
  .handler(async ({ data }) => {
    const { token } = data;
    if (!token) return null;
    try {
      const res = await api('get', `review/${token}`);
      return res.data;
    } catch (err) {
      return { error: err.response?.data?.message || 'Invalid or expired survey link.' };
    }
  });
